import { Component, Label, Sprite, _decorator } from 'cc';
import RemoteLoader from '../../../../common/scripts/Toolkit/Helper/Loading/RemoteLoader';
import NumberFormatter from '../../../../common/scripts/Toolkit/Components/Label/NumberFormatter';

const { ccclass, property } = _decorator;

@ccclass('UserInfo')
export default class UserInfo extends Component {
    @property(Sprite)
    public readonly avatarSprite: Sprite = null;

    @property(Label)
    public readonly nicknameLabel: Label = null;

    @property(NumberFormatter)
    public readonly balanceNumber: NumberFormatter = null;

    private _avatarURL = '';

    public set avatar(url: string) {
        if (url === this._avatarURL) {
            return;
        }
        this._avatarURL = url;
        if (!url) {
            this.avatarSprite.spriteFrame = null;
            return;
        }
        const spriteFrame = RemoteLoader.getSpriteFrame(url);
        if (spriteFrame) {
            this.avatarSprite.spriteFrame = spriteFrame;
            return;
        }
        this.avatarSprite.spriteFrame = null;
        RemoteLoader.loadSpriteFrame(url)
            .then((frame) => {
                this.avatarSprite.spriteFrame = frame;
            })
            .catch(() => {
                this.avatarSprite.spriteFrame = null;
            });
    }

    public set balance(value: number) {
        this.balanceNumber.value = value;
    }

    public set nickname(name: string) {
        this.nicknameLabel.string = name;
    }
}
